// frontend/src/components/mcbim/ColorFilterMenu.tsx
import React, { useMemo } from "react";
import { ActionIcon, Badge, Box, Button, Group, Menu, Text, Tooltip } from "@mantine/core";
import { MdPalette } from "react-icons/md";
import { FiCheck, FiChevronDown, FiX } from "react-icons/fi";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { selectGetColorFilters } from "../../Room/roomSelectors";
import { setActiveColorPanelItemInRedux } from "../designSlice";
import { COLOR_FILTERS_IDS } from "../LeftSidebar/ColorPanel/colorPanelUtils";

export const ColorFilterMenu: React.FC = () => {
  const dispatch = useAppDispatch();

  const colorFilters = useAppSelector(selectGetColorFilters);
  const activeColorPanelItem = useAppSelector((state) => state.design.activeColorPanelItem);

  const currentFilter = useMemo(
    () => colorFilters.find((f) => f.id === activeColorPanelItem),
    [colorFilters, activeColorPanelItem]
  );

  const hasActive = !!currentFilter;

  const currentLabel = currentFilter ? currentFilter.title : "Fargefilter";
  const tooltipLabel = hasActive ? "Fargefilter aktivt – klikk for å endre" : "Velg fargefilter";

  const handleSelect = (id: string | null) => {
    if (!id) {
      // slå av filter
      dispatch(setActiveColorPanelItemInRedux(undefined as unknown as COLOR_FILTERS_IDS));
      return;
    }
    dispatch(setActiveColorPanelItemInRedux(id as COLOR_FILTERS_IDS));
  };

  const handleClear = () => {
    handleSelect(null);
  };

  return (
    <Menu withinPortal position="bottom-start" shadow="md" width="500">
      <Menu.Target>
        <Tooltip label={tooltipLabel} withArrow position="bottom">
          <Button
            size="sm"
            variant={hasActive ? "filled" : "outline"}
            color={hasActive ? "blue" : undefined}
            radius="xl"
            leftSection={<MdPalette size={16} />}
            rightSection={
              <Group gap={4} wrap="nowrap">
                {hasActive && (
                  <ActionIcon
                    size={20}
                    radius="xl"
                    color="white"
                    variant="outline"
                    aria-label="Fjern fargefilter"
                    onMouseDown={(e) => {
                      // hindrer at menyen åpnes når vi bare vil nullstille
                      e.preventDefault();
                      e.stopPropagation();
                      handleClear();
                    }}
                  >
                    <FiX size={12} />
                  </ActionIcon>
                )}
                <FiChevronDown size={14} />
              </Group>
            }
            style={{ width: 300, justifyContent: "flex-start" }}
            styles={{
              label: {
                fontWeight: 500,
              },
            }}
          >
            <Text truncate>{currentLabel}</Text>
          </Button>
        </Tooltip>
      </Menu.Target>

      <Menu.Dropdown>
        <Box
          style={{
            maxHeight: 260,
            overflowY: "auto",
            paddingInline: 4,
          }}
        >
          {/* Ingen filter / reset */}
          <Menu.Item
            onClick={() => handleSelect(null)}
            leftSection={!hasActive ? <FiCheck size={14} /> : <span style={{ width: 14 }} />}
          >
            <Text size="sm">Ingen fargefilter</Text>
          </Menu.Item>

          <Menu.Divider />

          {colorFilters.map((filter) => {
            const isSelected = filter.id === activeColorPanelItem;

            return (
              <Menu.Item
                key={filter.id}
                onClick={() => handleSelect(filter.id)}
                leftSection={isSelected ? <FiCheck size={14} /> : <span style={{ width: 14 }} />}
                // rightSection={
                //   filter.badgeText ? (
                //     <Badge variant="light" size="xs" px={6}>
                //       {filter.badgeText}
                //     </Badge>
                //   ) : null
                // }
              >
                <Text size="sm" truncate>
                  {filter.title}
                </Text>
              </Menu.Item>
            );
          })}
        </Box>
      </Menu.Dropdown>
    </Menu>
  );
};
